// defined in Business Manager Sidebar
export const PATH_ROOT = '/';
export const PATH_CATEGORIES_INDEX = 'categories';
export const PATH_CATEGORIES_CREATE = 'create-category';
export const PATH_CATEGORIES_EDIT = 'categories/:categoryId/edit';
export const PATH_POST_CREATE = 'create-post';
export const PATH_SETTINGS = 'settings';

// has to be the same as in app
export const PATH_POST_EDIT = ':postSlug/edit';
export const PATH_POST_ADVANCED_SLUG_EDIT = ':year/:month/:postSlug/edit';
